import cobra from '../assets/cobra.png';
import ankh from '../assets/ankh.png';
import cat from '../assets/cat.png';
import falcon from '../assets/falcon.png';
import eye from '../assets/eye.png';
import env1 from '../assets/env1.png';
import env2 from '../assets/env2.png';
import env3 from '../assets/env3.png';
import env4 from '../assets/env4.png';
import env5 from '../assets/env5.png';
import env6 from '../assets/env6.png';
import env7 from '../assets/env7.png';
import env8 from '../assets/env8.png';
import env9 from '../assets/env9.png';
import env10 from '../assets/env10.png';

export const ROOM_SYMBOLS = {
  cobra: {
    id: 'cobra',
    image: cobra,
    glyph: '\u{13193}',
    clue: 'The crowned serpent waits without feet.'
  },
  ankh: {
    id: 'ankh',
    image: ankh,
    glyph: '\u{132F9}',
    clue: 'The looped key carries the breath of life.'
  },
  cat: {
    id: 'cat',
    image: cat,
    glyph: '\u{130E0}',
    clue: 'The silent guardian watches by moonlight.'
  },
  falcon: {
    id: 'falcon',
    image: falcon,
    glyph: '\u{13143}',
    clue: 'The winged hunter rules the sky.'
  },
  eye: {
    id: 'eye',
    image: eye,
    glyph: '\u{13080}',
    clue: 'The sacred watcher sees what is hidden.'
  }
};

export const ROOM_CODE_ICONS = Object.values(ROOM_SYMBOLS);

export const ROOM_PUZZLES = [
  {
    wallSymbols: ['ankh', 'falcon', 'eye'],
    code: ['falcon', 'eye', 'ankh'],
    clueStart: 9,
    clueEnd: 16
  },
  {
    wallSymbols: ['falcon', 'cat', 'cobra'],
    code: ['cat', 'cobra', 'falcon'],
    clueStart: 15,
    clueEnd: 22
  },
  {
    wallSymbols: ['ankh', 'eye', 'cat'],
    code: ['eye', 'cat', 'ankh'],
    clueStart: 21,
    clueEnd: 28
  },
  {
    wallSymbols: ['eye', 'cobra', 'falcon'],
    code: ['cobra', 'falcon', 'eye'],
    clueStart: 27,
    clueEnd: 34
  },
  {
    wallSymbols: ['cat', 'ankh', 'cobra'],
    code: ['ankh', 'cobra', 'cat'],
    clueStart: 33,
    clueEnd: 40
  },
  {
    wallSymbols: ['cobra', 'falcon', 'ankh'],
    code: ['falcon', 'ankh', 'cobra'],
    clueStart: 39,
    clueEnd: 46
  },
  {
    wallSymbols: ['falcon', 'cat', 'eye'],
    code: ['cat', 'eye', 'falcon'],
    clueStart: 45,
    clueEnd: 52
  },
  {
    wallSymbols: ['cobra', 'eye', 'ankh'],
    code: ['eye', 'ankh', 'cobra'],
    clueStart: 51,
    clueEnd: 58
  },
  {
    wallSymbols: ['eye', 'cobra', 'cat'],
    code: ['cobra', 'cat', 'eye'],
    clueStart: 57,
    clueEnd: 64
  },
  {
    wallSymbols: ['cat', 'ankh', 'falcon'],
    code: ['ankh', 'falcon', 'cat'],
    clueStart: 63,
    clueEnd: 70
  }
];

export const LEVEL_1_PUZZLE = ROOM_PUZZLES[0];

export const ENDLESS_ROOMS = [
  { backgroundImage: env1, door: { left: 63, top: 46 } },
  { backgroundImage: env2, door: { left: 71, top: 46 } },
  { backgroundImage: env3, door: { left: 65, top: 46 } },
  { backgroundImage: env4, door: { left: 77, top: 46 } },
  { backgroundImage: env5, door: { left: 61, top: 46 } },
  { backgroundImage: env6, door: { left: 61, top: 46 } },
  { backgroundImage: env7, door: { left: 27, top: 46 } },
  { backgroundImage: env8, door: { left: 70, top: 46 } },
  { backgroundImage: env9, door: { left: 70, top: 46 } },
  { backgroundImage: env10, door: { left: 30, top: 46 } }
];

const ENDLESS_SEED_KEY = 'endless_level_seed';

const getEndlessSeed = () => {
  const savedSeed = Number(localStorage.getItem(ENDLESS_SEED_KEY));

  if (savedSeed) return savedSeed;

  const seed = Math.floor(Math.random() * 2147483647) + 1;
  localStorage.setItem(ENDLESS_SEED_KEY, seed);
  return seed;
};

export const createEndlessRoom = (levelNumber) => {
  const mixedLevel = Math.imul(levelNumber + getEndlessSeed(), 2654435761) >>> 0;
  const roomIndex = mixedLevel % ENDLESS_ROOMS.length;
  const puzzleIndex = ((mixedLevel >>> 8) + levelNumber) % ROOM_PUZZLES.length;

  return {
    ...ENDLESS_ROOMS[roomIndex],
    puzzle: ROOM_PUZZLES[puzzleIndex]
  };
};
